export const HOURS_PER_DAY_MAX_VALUE = 24;
export const LOAD_MAX_VALUE = 500;
